function Contact() {
  return (
    <div className="container contact row" style={{ paddingTop: '4rem' }}>
      <div>
        <h2 className="main-title">대표이사 약력</h2>
        <div className="card-cover">
          <div className="col-md-12">
            <div className="col">
              <div>
                <p className="inline-text">2023.6 ~ : (주)디오모빌리티 대표이사</p>
                <p className="inline-text">2022.5 ~ 2023.5 : 서울특별시버스운송사업조합 실장(총괄)</p>
                <p className="inline-text">2014.7 ~ 2022.4 : 서울특별시버스운송사업조합 사업기획실 실장</p>
                <p className="inline-text">2009.3 ~ 2014.6 : 서울특별시버스운송사업조합 정책기획실 실장</p>
                <p className="inline-text">2003.11 ~ 2009.2 : 서울특별시버스운송사업조합 교통정책연구원 원장</p>
                <p className="inline-text">2002.9 ~ 2003.10 : 서울연구원 대중교통개편지원연구단 초빙연구위원</p>
                <p className="inline-text">2002.3 ~ 2002.8 : (주)창신종합엔지니어링 차장</p>
                <p className="inline-text">2002.3 ~ 2002.8 : 영남대학교 도시공학과 강사</p>
                <p className="inline-text">1999.4 ~ 2002.2 : 일본국립나고야공업대학(NIT) 교수</p>
                <p className="inline-text">1996.10 ~ 1998.9 : 일본국립오사카대학 강의 및 연구조교</p>
                <p className="inline-text">
                  1996.4 ~ 1999.3 : 일본국립오사카대학 대학원 토목공학과 Ph.D.(대중교통계획 전공)
                </p>
                <p className="inline-text">1995.10 ~ 1996.3 : 일본국립오사카대학 연구원</p>
                <p className="inline-text">1995.3 ~ 1995.9 : (주)창신종합엔지니어링 연구원</p>
                <p className="inline-text">
                  1993.3 ~ 1995.2 : 영남대학교 대학원 도시공학과 공학석사(도시 및 교통계획 전공)
                </p>
                <p className="inline-text">1988.5 ~ 1990.8 : 해병대 만기 전역</p>
                <p className="inline-text">1986.3 ~ 1993.2 : 영남대학교 공과대학 도시공학과 공학사(도시공학 전공)</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ marginLeft: '40px' }}>
        <h2 className="main-title">대표이사 활동</h2>
        <div className="card-cover">
          <div className="col-md-12">
            <div className="col">
              <div>
                <p className="inline-text">2026.10 ~ 2028.10 : 제5기 경상북도 재해영향평가심의위원회 심의위원</p>
                <p className="inline-text">
                  2026.10 : 제5차 의정부시 지방대중교통계획 수립 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">2026.10 ~ 2028.10 : 양산시 교통영향평가심의위원회 심의위원</p>
                <p className="inline-text">2026.10 ~ 2028.10 : 파주시 교통정책위원회 위원</p>
                <p className="inline-text">2026.10 ~ 2028.9 : 익산시 재해영향평가심의위원회 심의위원</p>
                <p className="inline-text">2026.10 ~ 2027.8 : 서울특별시 동대문구 도시계획위원회 위원</p>
                <p className="inline-text">2026.9 : 경주 황성지구 공동주택 신축(신규) 교통영향평가 심의위원</p>
                <p className="inline-text">
                  2026.9 : 제5차 경상북도 교통안전기본계획 수립 용역 제안서 평가위원회 위원장
                </p>
                <p className="inline-text">2026.9 ~ 2028.9 : 안성시 택시정책위원회 위원(재위촉)</p>
                <p className="inline-text">2026.8 : 대구시 주차종합계획 수립용역 제안서 평가위원회 위원</p>
                <p className="inline-text">2026.8 : 의왕시 편하G 버스 운송사업자 모집 제안서 평가위원회 위원</p>
                <p className="inline-text">
                  2026.8 : 경기도 광역 긴급차량 우선신호시스템 수도권 확대 사업 제안서 평가위원회 위원
                </p>
                <p className="inline-text">2026.8 ~ 2028.7 : 창원특례시 교통영향평가심의위원회 심의위원</p>
                <p className="inline-text">
                  2026.7 : 2026년 안동시 지능형교통체계(ITS) 유지관리 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">2026.7 : 부산광역시 자율주행 기본계획 수립 용역 제안서 평가위원회 위원</p>
                <p className="inline-text">
                  2026.7 : 신경주역세권 지역개발사업 B3-1블록 공동주택 신축공사(변경심의) 교통영향평가 심의위원
                </p>
                <p className="inline-text">
                  2026.6 : 2026년 제1회 강남구 주·정차위반 오프라인(대면) 의견진술심의위원회 위원
                </p>
                <p className="inline-text">2026.6 : 2026년 제1회 춘천시 노선버스 준공영제 관리위원회 부위원장</p>
                <p className="inline-text">2026.6 : 경기도(화성시) 똑버스 운송사업 제안서 평가위원회 위원</p>
                <p className="inline-text">
                  2026.6 : 창원시 제5차 교통안전기본계획(2027~2031) 수립 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2026.6 : 제5차 안동시 지방대중교통계획 및 교통약자 이동편의 증진계획 수립 용역 제안서 평가위원회
                  위원장
                </p>
                <p className="inline-text">
                  2026.6 : 2026 대구광역시 상습교통혼잡구간 도로개선 타당성 검토 연구용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2026.6 : 춘천시 주거안정과 균형발전을 위한 정비사업 추진기준 수립 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2026.5 : 2026년 부산광역시 버스정보관리시스템(BIMS) 추가 및 개선사업 제안서 평가위원회 위원
                </p>
                <p className="inline-text">2026.5 : 충청권 교통통합서비스 추진방안 연구용역 제안서 평가위원회 위원</p>
                <p className="inline-text">2026.5 : 안동시 도시교통정비 중기계획(안) 심의위원회 위원</p>
                <p className="inline-text">2026.5 : 제5차 경주시 지방대중교통계획 수립 용역 제안서 평가위원회 위원장</p>
                <p className="inline-text">2026.5 : 제5차 전라남도 교통안전기본계획 수립 용역 제안서 평가위원회 위원</p>
                <p className="inline-text">2026.4 : 제5차 경상남도 교통안전기본계획 수립 용역 제안서 평가위원회 위원</p>
                <p className="inline-text">2026.4 : 천안 테라C.C(비회원제골프장 27홀) 조성사업 교통영향평가 심의위원</p>
                <p className="inline-text">2026.4 : 천안시 서북구 예식장(아모르아트) 신축공사 교통영향평가 심의위원</p>
                <p className="inline-text">
                  2026.4 : 파주시 마을버스 회계감사 및 표준운송원가 산정 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2026.4 : 2026년 충청남도 노선버스 운송손익 분석 및 공정한 배분에 관한 연구용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2026.4 : 경산시 도시교통정비 기본계획 및 중기계획 수립 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2026.4 : 화성시 미래 모빌리티 실증도시 조성 및 종합계획 수립 연구용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2026.4 : 서해선 KTX 이음열차 소사역 정차를 위한 사전타당성 조사용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">2026.3 : 대구광역시 보행교통 종합계획 수립 용역 제안서 평가위원회 위원</p>
                <p className="inline-text">
                  2026.3 : 2026 경기도 시내버스업체 경영 및 서비스평가 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">2026.3 : 2026년 제1회 경기도 버스정책위원회 위원</p>
                <p className="inline-text">
                  2026.3 : 2026년 연무장길 「성동형 보행 안전거리」 운영 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2026.3 : 종로구 숭인지구단위계획 구역 내 도시계획시설(공원) 관리방안 마련 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">2026.3 : 청도용암온천 관광지 조성계획 교통영향평가(변경심의) 심의위원</p>
                <p className="inline-text">2026.3 : 김천의료원 건강검진센터 증축 교통영향평가 심의위원</p>
                <p className="inline-text">2026.3 : 위례과천선 선바위역 경유 타당성분석 제안서 평가위원회 위원</p>
                <p className="inline-text">2026.2 : 경기도·여주시 똑버스(DRT) 운송사업 제안서 평가위원회 위원</p>
                <p className="inline-text">2026.2 : 안성시 학생통학 순환버스 운송사업 제안서 평가위원회 위원</p>
                <p className="inline-text">
                  2026.2 : 2026년 전북특별자치도 시외버스 경영수지분석 및 운송원가 검증용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2026.2 : 나주시 버스업체 회계감사 및 2026년 표준운송원가 산정 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2026.2 : 2025 서울교통공사 지속가능경영보고서 발간 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">2026.2 : 하남시 학생통학 순환버스 운송사업자 모집 제안서 평가위원회 위원</p>
                <p className="inline-text">
                  2026.2 : 부산광역시 북항 모빌리티 특화도시 계획수립 용역 제안서 평가위원회 위원장
                </p>
                <p className="inline-text">
                  2026.1 : 울산도시철도 2호선 예비타당성조사 대응연구용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2026.1 : 천안 제5일반산업단지 조성사업 교통영향평가(4차 변경심의) 심의위원
                </p>
                <p className="inline-text">
                  2026.1 ~ 2027.12 : 경기도 공공관리제 평가 용역 및 노선입찰형 운송사업 제안서 평가위원회 위원
                </p>
                <p className="inline-text">2026.1 ~ 2027.12 : 강원특별자치도 옥외광고심의위원회 심의위원</p>
                <p className="inline-text">2025.12 : 2025년 용인시 똑버스 운송사업자 모집 제안서 평가위원회 위원</p>
                <p className="inline-text">
                  2025.12 : 2025년 용인시 신호제어시스템 SW 개선 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2025.12 : 2026년 대전광역시 버스운행관리시스템(BMS) 유지관리 용역 제안서 평가위원회 위원장
                </p>
                <p className="inline-text">2025.12 : 대구 DRT 서비스 평가 연구용역 제안서 평가위원회 위원</p>
                <p className="inline-text">
                  2025.12 : 2026년 서울시 버스정보시스템 유지보수 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">2025.12 ~ 2027.8 : 천안시 교통영향평가심의위원회 심의위원</p>
                <p className="inline-text">
                  2025.12 : 충청권 광역BRT 표준가이드라인 작성 정책연구 제안서 평가위원회 위원
                </p>
                <p className="inline-text">2025.12 : 2025년 제2회 춘천시 노선버스 준공영제 관리위원회 부위원장</p>
                <p className="inline-text">
                  2025.11 : 2025년 제2회 강남구 주·정차위반 오프라인(대면) 의견진술심의위원회 위원
                </p>
                <p className="inline-text">
                  2025.11 : 경기도 자전거 이용 활성화 5개년(2027~2031) 계획 제안서 평가위원회 위원
                </p>
                <p className="inline-text">2025.11 ~ 2027.11 : 광양시 교통영향평가심의위원회 심의위원</p>
                <p className="inline-text">
                  2025.11 : 진주시 시내버스 운전자 안전점수 평가 시스템 구축 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">2025.11 : 금천구 대중교통체계 개선대책 수립 용역 제안서 평가위원회 위원</p>
                <p className="inline-text">2025.10 : 구미 하이테크밸리 데이터센터 신축공사 교통영향평가 심의위원</p>
                <p className="inline-text">2025.10 : 김천 송천지구 택지개발사업 교통영향평가 심의위원</p>
                <p className="inline-text">
                  2025.10 : 관악구 공공문화시설 셔틀버스 모빌리티서비스 제공 용역 제안서 평가위원회 위원장
                </p>
                <p className="inline-text">
                  2025.10 : 사당16구역 주택재개발 정비계획 수립 및 정비구역 지정 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2025.10 : ’25년 하반기 경기도 광역·시내버스 공공관리제·마을버스 준공영제 운송사업 제안서 평가위원회
                  위원
                </p>
                <p className="inline-text">
                  2025.9 : 2025년 목포시 공영버스 경영 및 서비스평가 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2025.9 : 2025년 제1회 강남구 주·정차위반 오프라인(대면) 의견진술심의위원회 위원
                </p>
                <p className="inline-text">
                  2025.9 : 충주시 지능형교통체계(ITS) 기본계획 수립 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">2025.9 : 2035 김제시 도시재생전략계획 수립 용역 제안서 평가위원회 위원</p>
                <p className="inline-text">2025.9 : 성남시 도심항공교통(UAM) 추진계획 수립 제안서 평가위원회 위원</p>
                <p className="inline-text">
                  2025.9 : 제2차 경기도 철도시설 유지관리계획 수립 연구 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2025.9 ~ 2027.8 : 서울특별시 강남구 주·정차위반 의견진술심의위원회 심의위원
                </p>
                <p className="inline-text">
                  2025.8 : 구미시 도시교통정비기본계획(변경) 및 중기계획(안) 심의위원회 위원
                </p>
                <p className="inline-text">
                  2025.8 : 전라남도 스마트 버스운영체계 개편계획 수립 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">2025.8 : 평창군 수요응답형 플랫폼 서비스 운영사업 제안서 평가위원회 위원</p>
                <p className="inline-text">
                  2025.7 : 2025 관광교통 촉진 지역 공모사업(속초시) 한정면허 및 플랫폼사업자 제안서 평가위원회 위원
                </p>
                <p className="inline-text">2025.7 : 2025 완주산단 XR하이로드 스마트버스 구축 제안서 평가위원회 위원</p>
                <p className="inline-text">
                  2025.7 : 서울시 보행자 위험도 지표 개발 및 평가방안 연구 제안서 평가위원회 위원
                </p>
                <p className="inline-text">2025.7 : 진주시 DRT 한정면허 운송사업자 선정 제안서 평가위원회 위원</p>
                <p className="inline-text">2025.7 : 경기도 공유자전거 이용 요금 지원 사업 제안서 평가위원회 위원</p>
                <p className="inline-text">
                  2025.7 : 2025년 서울시 택시서비스 시민 만족도 및 인식 조사 분석 제안서 평가위원회 위원
                </p>
                <p className="inline-text">2025.7 : 2025년 제2회 경기도 버스정책위원회 위원</p>
                <p className="inline-text">2025.6 : 부산EDC 버스 한정면허 운송사업 사업자 선정위원회(2차) 위원</p>
                <p className="inline-text">2025.6 ~ 2027.6 : 춘천시 노선버스 준공영제 관리위원회 부위원장(재위촉)</p>
                <p className="inline-text">2025.6 : 부산 에코델타시티 버스 한정면허 운송사업 제안서 평가위원회 위원</p>
                <p className="inline-text">
                  2025.5 : 2025년 파주시 노선입찰형 마을버스(한정면허) 운송사업자 선정 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2025.5 : 2025년 경상북도 시외버스 경영수지분석 및 운송원가 검증용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2025.5 : 2025 대구광역시 상습교통혼잡구간 도로개선 타당성 검토 연구용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2025.5 : 2025년 대구광역시 일반택시 경영 및 서비스 평가 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2025.5 : 2025년도 경상북도 여객자동차운수사업자 경영 및 서비스평가 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2025.4 : 대구광역시 광역도로 건설 사전타당성조사 연구용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2025.4 : 서울시 버스정보시스템 실시간 위치정보 인프라 개선 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2025.4 : 2025년 경기도 택시 경영 및 서비스 평가 조사 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2025.4 : 서울특별시 성동구 성공버스 제2노선 및 제3노선 운행용역 제안서 평가위원회 위원장
                </p>
                <p className="inline-text">
                  2025.4 : 부산시 강서권역 수요응답형 교통(DRT) 한정면허 운송사업자 선정 제안서 평가위원회 위원
                </p>
                <p className="inline-text">2025.4 ~ 2027.3 : 경상북도 교통영향평가심의위원회 심의위원</p>
                <p className="inline-text">2025.3 : 2025년 고양시 마을버스 경영분석 연구용역 제안서 평가위원회 위원</p>
                <p className="inline-text">2025.3 ~ 2027.3 : 제11기 경기도 버스정책위원회 위원</p>
                <p className="inline-text">
                  2025.3 : 나주시 버스업체 회계감사 및 2025년 표준운송원가 산정 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">2025.3 : 밀양시 버스 노선체계 개편 용역 제안서 평가위원회 위원</p>
                <p className="inline-text">
                  2025.3 : 충북 시외버스 비수익노선 손실액산정 및 벽지노선 지정·손실액산정 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2025.3 : 부산광역시 시내버스 및 마을버스 표준운송원가 산정용역 제안서 평가위원회 위원장
                </p>
                <p className="inline-text">2025.3 : 김천버스 정밀 경영진단 및 회계감사 용역 제안서 평가위원회 위원</p>
                <p className="inline-text">2025.2 : 제천시 시내버스 노선체계 개편 연구용역 제안서 평가위원회 위원</p>
                <p className="inline-text">2025.2 ~ 2027.2 : 서울특별시 서초구 교통영향평가심의위원회 심의위원</p>
                <p className="inline-text">
                  2025.2 : 2025년 경기도 똑버스 서비스 플랫폼 CS센터 운영 및 관리 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">2025.2 : 경기도(수원시) 똑버스 운송사업 제안서 평가위원회 위원</p>
                <p className="inline-text">
                  2025.2 : 2025년 전북특별자치도 시외버스 경영수지분석 및 운송원가 검증용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2025.1 : 군산시 시내버스 노선체계 전면개편 수립 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">2024.12 ~ 2026.12 : 경상북도 교통위원회 위원</p>
                <p className="inline-text">
                  2024.12 : 2025년 대구광역시 대중교통마일리지시스템 유지관리 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2024.11 : 2025년 대전광역시 시내버스 디지털 노선안내도 유지관리 용역 제안서 평가위원회 위원장
                </p>
                <p className="inline-text">2024.11 : 2024년 제2회 춘천시 노선버스 준공영제 관리위원회 부위원장</p>
                <p className="inline-text">
                  2024.10 : 파주시 시내버스(좌석형) 한정면허 운송사업 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2024.9 : 안동시 대중교통(시내버스, 택시) 운수종사자 서비스 평가 용역 제안서 평가위원회 위원장
                </p>
                <p className="inline-text">
                  2024.9 : 2024년 하반기 경기도 시내버스 공공관리제 노선입찰형 운송사업 제안서 평가위원회 위원장
                </p>
                <p className="inline-text">
                  2024.9 : 2024년 제2차 파주시 노선입찰형 마을버스(한정면허) 운송사업자 선정 제안서 평가위원회 위원
                </p>
                <p className="inline-text">2024.9 ~ 2026.9 : 안성시 택시정책위원회 위원</p>
                <p className="inline-text">
                  2024.8 : 부산광역시 빅데이터 기반 시내버스운행관리 분석시스템 개발 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2024.8 : 2024년 울산광역시 일반택시 경영 및 서비스 평가 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">2024.7 : 2024년 제1회 춘천시 노선버스 준공영제 관리위원회 부위원장</p>
                <p className="inline-text">
                  2024.7 : 2024년 대전광역시 시내버스 디지털 노선안내도 구축 사업 제안서 평가위원회 위원장
                </p>
                <p className="inline-text">
                  2024.7 : 경기교통공사 버스 운송비용 정산시스템 유지관리 사업 제안서 평가위원회 위원장
                </p>
                <p className="inline-text">
                  2024.6 : 익산시 자율주행 스마트플랫폼 구축 기본설계 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2024.5 : 대구광역시 도로건설·관리계획(’26~’30) 수립 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2024.5 : 2024년 충남 노선버스 운송손익 분석 및 공정한 배분에 관한 연구용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2024.5 : 2024년 경기도 공공버스 운수종사자 교육 및 조사 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2024.5 : 2024년 하남시 도시형교통모델 운송사업자 모집 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2024.4 : 괴산군 농어촌버스 노선개편 및 운영 효율화 방안 연구용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2024.4 : 광명권 광역도시철도망 기본구상 및 사전타당성조사 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2024.4 : 2023년 제2차 경기도 공공버스 운송사업 노선입찰 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2024.3 : 군위군 관내 간선도로망 구축을 위한 연구용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2024.3 : 2024 경기도 시내버스업체 경영 및 서비스평가 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">2024.3 : 대구형 DRT 운영 타당성 용역 제안서 평가위원회 위원</p>
                <p className="inline-text">
                  2024.3 : 나주시 시내버스 업체 회계감사 및 표준운송원가 산정 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">2024.3 : 광주시 똑버스 운송사업 제안서 평가위원회 위원</p>
                <p className="inline-text">
                  2024.3 : 하빈 동곡~감문간 도로건설 사업구간 연장 타당성 검토 용역 제안서 평가위원회 위원
                </p>
                <p className="inline-text">2024.3 : 고양시 똑버스 운송사업 제안서 평가위원회 위원</p>
                <p className="inline-text">
                  2024.2 ~ 2025.12 : 경기교통공사 노선입찰형 준공영제 사업 제안서 평가위원회 위원
                </p>
                <p className="inline-text">
                  2024.1 : 서울특별시 관악구 마을버스 운송사업자 선정 제안서 평가위원회 위원
                </p>
                <p className="inline-text">2023.11 : 2023년 제2회 춘천시 노선버스 준공영제 관리위원회 부위원장</p>
                <p className="inline-text">
                  2023.11 : 2023년 하남시 도시형교통모델 운송사업자 모집 제안서 평가위원회 위원
                </p>
                <p className="inline-text">2023.6 : 구미시 시내버스 노선개편 용역 제안서 평가위원회 위원 및 자문위원</p>
                <p className="inline-text">2023.6 : 2023년 제1회 춘천시 노선버스 준공영제 관리위원회 부위원장</p>
                <p className="inline-text">2023.6 ~ 2025.6 : 춘천시 노선버스 준공영제 관리위원회 부위원장</p>
                <p className="inline-text">2008.4 ~ 2012.3 : 서울특별시 교통약자이동편의증진위원회 위원</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Contact;
